import React, { useEffect, useState } from 'react';
import { CarouselProps } from 'react-multi-carousel';
import classNames from 'classnames';
import WidgetPhotosGridTeaserManualProps
    from 'modules/shared/widgets/components/widget-photos-grid-teaser-manual/widget-photos-grid-teaser-manual.props';
import WidgetCarouselDesktopBasic
    from '../../../../widget-carousel/widget-carousel-deskktop/components/widget-carousel-desktop-basic/widget-carousel-desktop-basic';

import './widget-photos-grid-teaser-manual-desktop-slider.scss';

interface WidgetPhotosGridTeaserManualDesktopSliderProps extends WidgetPhotosGridTeaserManualProps {
    isSliderSmall: boolean;
}

const WidgetPhotosGridTeaserManualDesktopSlider: React.FC<WidgetPhotosGridTeaserManualDesktopSliderProps> = ({ config, data, isSliderSmall }) => {
    const [WidgetPhotosGridTeaserCarouselComponent, setWidgetCarousel] = useState<React.ComponentType<CarouselProps>>(() => WidgetCarouselDesktopBasic);
    const numberOfItems = isSliderSmall ? 3 : 5;

    useEffect(() => {
        import('react-multi-carousel').then(mod => {
            setWidgetCarousel(() => mod.default);
        });
    }, []);

    const responsive = {
        desktop: {
            breakpoint: { max: 5000, min: 1024 },
            items: numberOfItems
        }
    };

    return (
        <div className={classNames({
            'widget-photo-grid-teaser-manual-carousel': true,
            'widget-photo-grid-teaser-manual-carousel__small': numberOfItems === 3
        })}
        >
            <WidgetPhotosGridTeaserCarouselComponent
                responsive={responsive}
                swipeable={false}
                draggable={false}
                slidesToSlide={numberOfItems}
                renderButtonGroupOutside={true}
                arrows={true}
                autoPlay={config.autoPlay}
                className="w-carousel-d__list"
                itemClass={`w-carousel-d__list__item w-${numberOfItems}`}
            >
                {data.map((item, idx) => (
                    <div key={`${idx}`} className="slider__list__item-wrapper-manual">
                        <a
                            href={item.url}
                            title={item.title}
                            className="slider__list__item-content-manual"
                            target={item.target}
                            rel={item.target === '_blank' ? 'nofollow noopener' : ''}
                        >
                            <div
                                className={'slider__list__item-content-manual__image'}
                            >
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    title={item.title}
                                    loading={config.lazyLoad ? 'lazy' : 'eager'}
                                />
                            </div>
                            <div className="slider__list__item-content-manual__title">
                                <h3>
                                    {item.title}
                                </h3>
                            </div>
                            <div className="slider__list__item-content-manual__cta">
                                <button className="slider__list__item-content-manual__cta__button button button--primary button--md button--fw-500">
                                    {item.cta}
                                </button>
                            </div>
                        </a>
                    </div>
                ))}
            </WidgetPhotosGridTeaserCarouselComponent>
        </div>
    );
};

export default WidgetPhotosGridTeaserManualDesktopSlider;
